<template>
    <div class="good" :class="classes" @click="onClick">
        <div v-if="title && !disabled" class="good__title">
            {{ title }}
            <icon-arrow-right class="good__title-icon" />
        </div>

        <div class="good__img">
            <block-good-img :id="id" />
        </div>
        <template v-if="disabled">
            <div class="good__img">
                <block-good-img :id="id" disabled />
            </div>

            <img class="good__check" src="@/assets/icons/check.svg" />
        </template>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            id: {
                type: Number,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            }
        },
        computed: {
            classes () {
                return {
                    [`good--id-${this.id}`]: true,
                    [`good--disabled`]: this.disabled
                }
            }
        },
        methods: {
            onClick () {
                if (!this.disabled) {
                    this.$emit('click')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .good {
        position relative
        padding-bottom 73.4%
        overflow hidden
        background-color #3665F3
        width 100%
        cursor pointer

        &__img {
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            transform translate(0, 1.7rem)

            img {
                width 100%
                height 100%
            }
        }

        &__check {
            position absolute
            bottom 1rem
            right 1rem
            z-index 3
            width 3rem
            height 3rem
        }

        &__title {
            position absolute
            padding 1rem 1.2rem
            bottom 0
            left 0
            right 0
            background-color #121258
            color #C5E5FB
            font-size 1.5rem
            line-height 1.6rem
            z-index 5
            transform translate(0, 100%)
            transition transform 0.3s ease
            user-select none
            display flex
            align-items center
            justify-content space-between

            +layout-xs() {
                display none!important
            }

            &-icon {
                flex-shrink 0
                margin-left 0.5rem
                width 1rem
                height 1.4rem
            }
        }

        &:hover &__title {
            transform translate(0, 0)
        }

        &--disabled {
            background-color #C5E5FB
            pointer-events none
        }

        &--id-1 &__img {
            transform translate(0.9rem, 1.7rem)
        }

        &--id-2 &__img {
            transform translate(0.1rem, 1.7rem) scale(0.9)
            +layout-xs() {
                transform translate(-0.4rem, 1.3rem) scale(0.9)
            }
        }

        &--id-3 &__img {
            transform translate(0.9rem, 1.7rem)
        }

        &--id-4 &__img {
            transform translate(0.5rem, 2.1rem)
            +layout-xs() {
                transform translate(0.5rem, 1.4rem)
            }
        }

        &--id-5 &__img {
            transform translate(0.1rem, 0.2rem) scale(0.8)
        }

        &--id-6 &__img {
            transform translate(0.1rem, 3.4rem) scale(0.8)
            +layout-xs() {
                transform translate(0.1rem, 2.3rem) scale(0.8)
            }
        }

        &--id-7 &__img {
            transform translate(0.1rem, 1.9rem)
        }
    }
</style>
